export const SIDENAV_WIDTH = 248;
export const MINI_SIDENAV_WIDTH = 68;
export const PORTAL_HEADER_HEIGHT = 58;
